import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { Button, TextInput } from '/src/components/common'
import { postRequest } from '/src/httpClient'

export const SubscribeForm = () => {
  const { register, handleSubmit, formState: { errors } } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState(false)

  const onSubmit = (data) => {
    if (data) {
      setIsLoading(true)
      postRequest('/api/user/subscribe', data).then(response => {
        if (response) {
          setMessage('Thank you for subscribing.')
        }
        else {
          setMessage('Thank you for subscribing')
        }

        setIsLoading(false)
      })
    }
  }

  return (
    <div className="subscribe-form-container">
      <form id="subscribe-form" name="subscribe-form" onSubmit={handleSubmit(onSubmit)}>
        {message ? (
          <Row>
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              <p>{message}</p>
            </Col>
          </Row>
        ) :(
          <Row>
            <Col md={4}>
              <TextInput
                placeholder="Email"
                error={errors.email}
                register={register('email', {
                  placeholder: 'Email',
                  required: true,
                  pattern: {
                    value: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                    message: 'Please provide a valid email address'
                  }
                })} />
            </Col>
            <Col md={4}>
              <TextInput
                placeholder="First name"
                register={register('first_name', {
                  placeholder: 'First Name',
                  required: true,
                })} />
            </Col>
            <Col md={4}>
              <TextInput
                placeholder="Last name"
                register={register('last_name', {
                  placeholder: 'Last Name',
                  required: true,
                })} />
              <Button disabled={isLoading} variant="primary" type="submit">
                Subscribe
                <FontAwesomeIcon icon={faArrowRight} />
              </Button>
            </Col>
          </Row>
        )}
      </form>
    </div>
  )
}